import { Background } from '@app/core/utils/background';
import { SessionService } from '../session.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ErrorDisplayComponent } from '../../shared/error-display/error-display.component';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: true,
    imports: [NgClass, FormsModule, ReactiveFormsModule, ErrorDisplayComponent, SpinnerComponent, RouterLink]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  submitted: boolean;
  requestInFlight: boolean;
  error: string;
  now: Date;
  loginFormGroup: UntypedFormGroup;

  constructor(private sessionService: SessionService,
              private formBuilder: UntypedFormBuilder) {
    this.loginFormGroup = formBuilder.group({
      'username': [null, [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    Background.loginOn();
    this.now = new Date();
  }

  ngOnDestroy() {
    Background.loginOff();
  }

  reset(): void {
    this.submitted = false;
    this.error = undefined;
  }

  submitForgotLogin(): void {
    this.submitted = false;
    this.error = undefined;

    const controls = this.loginFormGroup.controls;
    for (const control in controls) {
      if (controls.hasOwnProperty(control)) {
        controls[control].markAsTouched();
      }
    }

    if (this.loginFormGroup.valid) {
      this.requestInFlight = true;
      this.sessionService.forgotPassword(this.loginFormGroup.controls['username'].value).subscribe(
        r => {
          this.submitted = true;
          this.requestInFlight = false;
        },
        err => {
          this.submitted = true;
          this.requestInFlight = false;
          this.parseError(err);
        });
    }

  }

  checkForEnter(event): void {
    if (event.keyCode === 13) {
      this.submitForgotLogin();
    }
  }

  private parseError(err: any) {
    this.error =
      err?.error?.reason ||
      err?.error?.message ||
      'An error occurred. Please try again.';
  }

}
